import { OrganizationMember } from '@prisma/client'
import { useMemo } from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { AppUISettings } from '~/features/app/clientShared'
import { useConversationParticipants } from '../../Thread/hooks/useConversationParticipants'
import { useOtherParticipants } from '../../Thread/hooks/useOtherParticipants'

export type DataApp = { key: string; uiSettings: AppUISettings }

type Props = {
  conversationId: string
  organizationMember: OrganizationMember
  organizationMembers: OrganizationMemberFromContext[]
}

export const useData = ({
  organizationMember,
  organizationMembers,
  conversationId,
}: Props) => {
  const { participants } = useConversationParticipants({
    conversationId,
  })

  const { members } = useOtherParticipants({
    organizationMember,
    participants,
    organizationMembers,
  })

  const member = useMemo(() => {
    return members[0]
  }, [members])

  const appSession = member?.organizationMember?.appSession
  const app = appSession?.app as any as DataApp
  const organizationMemberAgent = member?.organizationMember

  return {
    member,
    appSession,
    app,
    organizationMemberAgent,
  }
}
